import { ComboBoxDropDownItem } from "@/Common/Components/Inputs/Combobox";
import { LuxonDateTimeParser } from "@/Common/Utilities/DateAndTime/LuxonDateTimeParser";
import { OntarioPatientEnrollmentTerminationReasonCode } from "./OntarioPatientEnrollmentTerminationReasonCode";

class OntarioPatientEnrollmentModel {
    private static readonly terminationCodeStringPrefix = "OntarioPatientEnrolment_TerminationCodes_";
    private static readonly TerminationCodes =
        [
            OntarioPatientEnrollmentTerminationReasonCode.HealthNumberError,
            OntarioPatientEnrollmentTerminationReasonCode.PatientIdentifiedAsDeceasedOnMinistryDatabase,
            OntarioPatientEnrollmentTerminationReasonCode.PatientAddedToRosterInError,
            OntarioPatientEnrollmentTerminationReasonCode.MemberNowEnrolledWithRedAndWhiteHealthCard,
            OntarioPatientEnrollmentTerminationReasonCode.MemberNowEnrolledWithPhotoHealthCard,
            OntarioPatientEnrollmentTerminationReasonCode.ConfidentialCode33,
            OntarioPatientEnrollmentTerminationReasonCode.PatientTransferredFromRosterPerPhysicianRequest,
            OntarioPatientEnrollmentTerminationReasonCode.PatientNowReEnrolled,
            OntarioPatientEnrollmentTerminationReasonCode.PatientNowEnrolledAsLongTermCare,
            OntarioPatientEnrollmentTerminationReasonCode.PatientLongTermCareEnrollmentEnded,
            OntarioPatientEnrollmentTerminationReasonCode.MemberRosterTransferredPerPhysicianRequest,
            OntarioPatientEnrollmentTerminationReasonCode.PhysicianReportedMemberAsDeceased,
            OntarioPatientEnrollmentTerminationReasonCode.PatientAssignedToAnotherPhysician,
            OntarioPatientEnrollmentTerminationReasonCode.PatientEnteredLongTermCareFacility,
            OntarioPatientEnrollmentTerminationReasonCode.PhysicianEndedPatientEnrollment,
            OntarioPatientEnrollmentTerminationReasonCode.PatientNoLongerMeetsSelectionCriteriaForRoster,
            OntarioPatientEnrollmentTerminationReasonCode.PatientMovedOutOfGeographicArea,
            OntarioPatientEnrollmentTerminationReasonCode.PatientLeftProvince,
            OntarioPatientEnrollmentTerminationReasonCode.PerPatientRequest,
            OntarioPatientEnrollmentTerminationReasonCode.EnrollmentTerminatedByPatient,
            OntarioPatientEnrollmentTerminationReasonCode.PatientOutOfGeographicArea,
            OntarioPatientEnrollmentTerminationReasonCode.NoCurrentEligibilityCode60,
            OntarioPatientEnrollmentTerminationReasonCode.AppliedAddressOverrideForPatientOutOfArea,
            OntarioPatientEnrollmentTerminationReasonCode.RemovedAddressOverrideForPatientOutOfArea,
            OntarioPatientEnrollmentTerminationReasonCode.NoCurrentEligibilityCode73,
            OntarioPatientEnrollmentTerminationReasonCode.NoCurrentEligibilityCode74,
            OntarioPatientEnrollmentTerminationReasonCode.EnrollmentOrConsentFormNotReceivedByMinistry,
            OntarioPatientEnrollmentTerminationReasonCode.ConfidentialialCode84,
            OntarioPatientEnrollmentTerminationReasonCode.ConfidentialialCode90,
            OntarioPatientEnrollmentTerminationReasonCode.ConfidentialialCode91
        ];

    public Id: string;
    public EnrolledPhysicianId: string;
    public EnrollmentStartDate: Date;
    public EnrollmentEndDate?: Date;
    public TerminationReasonCode?: OntarioPatientEnrollmentTerminationReasonCode;

    public constructor(fields?: Partial<OntarioPatientEnrollmentModel>) {
        Object.assign(this, fields);
        this.EnrollmentStartDate = LuxonDateTimeParser.parse(fields?.EnrollmentStartDate)?.toJSDate();
        this.EnrollmentEndDate = LuxonDateTimeParser.parse(fields?.EnrollmentEndDate)?.toJSDate();
    }

    public static GetTerminationCodeString(code?: OntarioPatientEnrollmentTerminationReasonCode): string {
        return code
            ? cacheStore.GetString(`${this.terminationCodeStringPrefix}${OntarioPatientEnrollmentTerminationReasonCode[code]}`) + ` (${code})`
            : "";
    }

    public static GetTerminationCodeComboboxItems(): ComboBoxDropDownItem[] {
        return this.TerminationCodes
            .map(code => new ComboBoxDropDownItem(code.toString(), this.GetTerminationCodeString(code)));
    }

    public isCurrentEnrollment(): boolean {
        return !LuxonDateTimeParser.parse(this.EnrollmentEndDate)?.isValid;
    }
}

export { OntarioPatientEnrollmentModel };
